<div class="modal-header">
    <ion-grid class="ion-no-padding">
        <ion-row class="ion-no-padding">
            <ion-col size="10"
                     class="ion-no-padding">
                <ng-container *ngIf="!!chatGroup.id">
                    {{ 'CHAT_GROUP_EDIT' | translate }}
                </ng-container>
                <ng-container *ngIf="!chatGroup.id">
                    {{ 'CHAT_GROUP_NEW' | translate }}
                </ng-container>
            </ion-col>
            <ion-col size="2"
                     class="ion-no-padding ion-text-right">
                <a (click)="close()">
                    <svg-icon [applyClass]="true"
                              src="/assets/icons/ico-close.svg"
                              class="icon fill-dark">
                    </svg-icon>
                </a>
            </ion-col>
        </ion-row>
    </ion-grid>
</div>

<form method="get"
      #f="ngForm"
      role="form"
      novalidate>
    <ion-grid *ngIf="user"
              class="ion-no-padding">

        <ng-container *ngIf="invitationtsOpen">

            <ion-row class="ion-no-padding">
                <ion-col class="ion-no-padding">
                    <p>{{ 'CHAT_GROUP_INVITATIONS_HINT' | translate }}
                    <p>
                </ion-col>
            </ion-row>

            <ion-row class="ion-no-padding">
                <ion-col class="ion-no-padding">
                    <ion-searchbar [placeholder]="'ATTENDEE_LIST_SEARCH_PLACEHOLDER' | translate"
                                   name="atttendee-search"
                                   style="padding: 0;"
                                   [debounce]="500"
                                   enterkeyhint="search"
                                   [(ngModel)]="searchString"
                                   (onenter)="searchAttendees()"
                                   (ionChange)="searchAttendees()">
                    </ion-searchbar>
                </ion-col>
            </ion-row>
            <ion-row class="ion-no-padding">
                <ion-col class="ion-no-padding">
                    <div class="attendee-list"
                         infiniteScroll
                         [infiniteScrollDisabled]="loading"
                         [infiniteScrollDistance]="2"
                         [infiniteScrollThrottle]="150"
                         [scrollWindow]="false"
                         [alwaysCallback]="true"
                         (scrolled)="searchAttendees(false)">
                        <div *ngFor="let item of items; let c = index"
                             (click)="toggleAttendee(item)"
                             class="participant"
                             [ngClass]="{'selected': item.selected}">
                            <ion-avatar>
                                <img *ngIf="!item.selected"
                                     class="avatar"
                                     img-avatar
                                     [src]="user.canPicture(item) ? item.picture_url : ''"
                                     alt="">
                                <ion-icon *ngIf="item.selected"
                                          name="checkmark">
                                </ion-icon>
                            </ion-avatar>

                            <div class="detail">
                                <h3>{{ item.firstname }} {{ item.lastname }}</h3>
                            </div>
                        </div>
                    </div>
                </ion-col>
            </ion-row>

        </ng-container>
        <ng-container *ngIf="!invitationtsOpen">

            <ng-container *ngIf="!autocompleteOpen || !plt.sizeSm">

                <ion-row class="ion-no-padding">
                    <ion-col class="ion-no-padding">
                        <ion-item class="ion-no-padding"
                                  [ngClass]="{ 'has-error': validate && validationErrors['translations.0.name'] }">
                            <ion-label position="stacked">
                                {{ 'CHAT_GROUP_NAME' | translate }}
                            </ion-label>
                            <ion-input type="text"
                                       name="chatGroupName"
                                       #chatGroupName="ngModel"
                                       (ionFocus)="plt.checkResize()"
                                       (ionBlur)="plt.checkResize(false)"
                                       [(ngModel)]="chatGroup.name"
                                       required>
                            </ion-input>
                        </ion-item>
                        <span *ngIf="(chatGroupName.touched || validate) && !chatGroupName.valid"
                              class="error-message">
                            {{ 'CHAT_GROUP_VALIDATION_NAME' | translate }}
                        </span>
                        <span *ngIf="validate && validationErrors['translations.0.name']"
                              class="error-message">
                            {{ validationErrors['translations.0.name'] }}
                        </span>
                    </ion-col>
                </ion-row>

                <ion-row class="ion-no-padding">
                    <ion-col class="ion-no-padding">
                        <ion-item class="ion-no-padding"
                                  [ngClass]="{ 'has-error': validate && validationErrors['translations.0.description'] }">
                            <ion-label position="stacked">{{ 'CHAT_GROUP_DESCRIPTION' | translate }}</ion-label>
                            <ion-textarea placeholder=""
                                          ieTextareaFix
                                          name="description"
                                          #description="ngModel"
                                          inputmode="text"
                                          spellcheck="false"
                                          autocapitalize="off"
                                          (ionFocus)="plt.checkResize()"
                                          (ionBlur)="plt.checkResize(false)"
                                          [(ngModel)]="chatGroup.description">
                            </ion-textarea>
                        </ion-item>
                        <span *ngIf="validate && validationErrors['translations.0.description']"
                              class="error-message">
                            {{ validationErrors['translations.0.description'] }}
                        </span>
                    </ion-col>
                </ion-row>

                <ion-row *ngIf="user?.canGroupVideoCall() || chatGroup.appointment_id"
                         class="ion-no-padding">
                    <ion-col class="ion-no-padding">
                        <ion-label position="stacked">
                            &nbsp;
                        </ion-label>
                        <ion-item style="padding:0">
                            <ion-checkbox *ngIf="!chatGroup.appointment_id"
                                          name="online"
                                          [(ngModel)]="chatGroup.allow_call">
                            </ion-checkbox>
                            <ion-checkbox *ngIf="chatGroup.appointment_id"
                                          name="online"
                                          checked="true">
                            </ion-checkbox>
                            <ion-label>{{ 'ALLOW_VIDEO_CHAT_GROUP' | translate }}</ion-label>
                        </ion-item>
                    </ion-col>
                </ion-row>

                <ion-row class="ion-no-padding">
                    <ion-col class="ion-no-padding">
                        <ion-item class="ion-no-padding">
                            <ion-label position="stacked">
                                {{ 'CHAT_GROUP_STATUS' | translate }}
                            </ion-label>
                            <ion-select [interface]="selectType"
                                        [cancelText]="'BUTTON_CANCEL' |  translate"
                                        name="status"
                                        #status="ngModel"
                                        [disabled]="chatGroup.appointment_id"
                                        [(ngModel)]="chatGroup.status">
                                <ion-select-option *ngIf="event?.can(user.selected_participant.group_id, 'allow_chat_group_creation')"
                                                   [value]="0">{{ 'CHAT_GROUP_STATUS_0' | translate }}</ion-select-option>
                                <ion-select-option *ngIf="event?.can(user.selected_participant.group_id, 'allow_private_chat_group_creation')"
                                                   [value]="1">
                                    <ng-container *ngIf="chatGroup.appointment_id">{{ 'CHAT_GROUP_STATUS_APPOINTMENT' | translate }}</ng-container>
                                    <ng-container *ngIf="!chatGroup.appointment_id">{{ 'CHAT_GROUP_STATUS_1' | translate }}</ng-container>
                                </ion-select-option>
                                <ion-select-option *ngIf="event?.can(user.selected_participant.group_id, 'allow_secured_chat_group_creation')"
                                                   [value]="2">{{ 'CHAT_GROUP_STATUS_2' | translate }}</ion-select-option>
                            </ion-select>
                        </ion-item>
                    </ion-col>
                </ion-row>

                <!-- private groups -->
                <ng-container *ngIf="chatGroup.status == 1">
                    <ion-row *ngIf="chatGroup.id"
                             class="ion-no-padding">
                        <ion-col class="ion-no-padding">
                            <ion-button *ngIf="!chatGroup.appointment_id"
                                        (click)="searchAttendees()">
                                {{ 'CHAT_GROUP_INVITATIONS_BTN' | translate }}
                            </ion-button>
                        </ion-col>
                    </ion-row>
                    <ion-row class="ion-no-padding hint">
                        <ion-col class="ion-no-padding">
                            {{ 'CHAT_GROUP_STATUS_1_HINT' | translate }}
                        </ion-col>
                    </ion-row>
                </ng-container>

                <!-- private groups with password -->
                <ng-container *ngIf="chatGroup.status == 2">
                    <ion-row class="ion-no-padding">
                        <ion-col class="ion-no-padding">
                            <ion-item class="ion-no-padding"
                                      [ngClass]="{ 'has-error': validate && validationErrors['password'] }">
                                <ion-label position="stacked">
                                    {{ 'CHAT_GROUP_PASSWORD' | translate }}
                                </ion-label>
                                <ion-input type="text"
                                           name="password"
                                           #password="ngModel"
                                           (ionFocus)="plt.checkResize()"
                                           (ionBlur)="plt.checkResize(false)"
                                           [(ngModel)]="chatGroup.password"
                                           required>
                                </ion-input>
                            </ion-item>
                            <span *ngIf="validate && validationErrors['password']"
                                  class="error-message">
                                {{ validationErrors['password'] }}
                            </span>
                        </ion-col>
                    </ion-row>

                    <ion-row class="ion-no-padding hint">
                        <ion-col class="ion-no-padding">
                            {{ 'CHAT_GROUP_STATUS_2_HINT' | translate }}
                        </ion-col>
                    </ion-row>
                </ng-container>

                <ion-row class="ion-no-padding">
                    <ion-col class="ion-no-padding">
                        <h4>{{ 'CHAT_GROUP_MODERATORS' | translate }}</h4>
                    </ion-col>
                </ion-row>

                <ion-row class="ion-no-padding">
                    <ion-col class="ion-no-padding">
                        <div class="moderator">
                            {{ user.selected_participant.firstname }} {{ user.selected_participant.lastname }}
                        </div>
                        <ng-container *ngFor="let moderator of chatGroup.admins">
                            <div *ngIf="user.selected_participant_id != moderator.participant_id"
                                 class="moderator">
                                {{moderator.participant.firstname}} {{moderator.participant.lastname}}
                                <svg-icon (click)="removeModerator(moderator)"
                                          [applyClass]="true"
                                          src="/assets/icons/ico-close.svg"
                                          class="icon fill-dark">
                                </svg-icon>
                            </div>
                        </ng-container>
                    </ion-col>
                </ion-row>

            </ng-container>

            <ion-row class="ion-no-padding">
                <ion-col class="ion-no-padding">

                    <ng-template #emptyTemplate
                                 let-attrs="attrs"
                                 class="ion-text-center">
                        {{ 'CHAT_GROUP_MODERATORS_NO_ITEMS' | translate }}
                    </ng-template>
                    <ng-template #participantTemplate
                                 let-attrs="attrs">
                        {{attrs.data.firstname}} {{attrs.data.lastname}}
                    </ng-template>
                    <ion-auto-complete *ngIf="!chatGroup.appointment_id"
                                       #autocomplete
                                       [dataProvider]="participantService"
                                       [dataProviderAttribute]="'participants'"
                                       [exclude]="chatGroup.admins"
                                       [template]="participantTemplate"
                                       [selectionTemplate]="participantTemplate"
                                       [emptyTemplate]="emptyTemplate"
                                       [options]="{mode: 'ios', placeholder: 'ATTENDEE_LIST_SEARCH_PLACEHOLDER' | translate }"
                                       (ionAutoInput)="autocompleteFocus()"
                                       (itemsShown)="autocompleteFocus()"
                                       (itemsHidden)="autocompleteBlur()"
                                       (autoBlur)="autocompleteBlur()"
                                       (itemSelected)="addModerator($event)">
                    </ion-auto-complete>
                </ion-col>
            </ion-row>

            <ion-row *ngIf="!autocompleteOpen && plt.sizeSm && !!chatGroup.id"
                     class="ion-no-padding">
                <ion-col class="ion-no-padding">
                    <ion-button *ngIf="!chatGroup.appointment_id"
                                class="btn-close delete"
                                (click)="deleteChatGroup()">
                        {{ 'CHAT_GROUP_DELETE' | translate }}
                    </ion-button>
                </ion-col>
            </ion-row>

            <ion-row *ngIf="!chatGroup.id"
                     class="ion-no-padding hint">
                <ion-col class="ion-no-padding">
                    {{ 'CHAT_GROUP_NEW_HINT' | translate }}
                </ion-col>
            </ion-row>
        </ng-container>

    </ion-grid>
</form>

<ion-footer>
    <ng-container *ngIf="!autocompleteOpen || !plt.sizeSm">
        <ion-row *ngIf="!plt.sizeSm"
                 class="ion-no-padding">
            <ion-col *ngIf="!!chatGroup.id"
                     size="5"
                     class="ion-no-padding ion-text-left">
                <ion-button *ngIf="!chatGroup.appointment_id"
                            class="delete"
                            (click)="deleteChatGroup()">
                    {{ 'CHAT_GROUP_DELETE' | translate }}
                </ion-button>
            </ion-col>
            <ion-col class="ion-no-padding ion-text-right">
                <ion-button class="btn-close"
                            (click)="close()">
                    {{ 'BUTTON_CANCEL' | translate }}
                </ion-button>
                <ion-button *ngIf="chatGroup.status == 1 && !invitationtsOpen"
                            [disabled]="!f.form.valid"
                            (click)="saveChatGroup(f.form.valid, !chatGroup.id)">
                    <ng-container *ngIf="chatGroup.id">
                        {{ 'BUTTON_SAVE' | translate }}
                    </ng-container>
                    <ng-container *ngIf="!chatGroup.id">
                        {{ 'BUTTON_SAVE_AND_NEXT' | translate }}
                    </ng-container>
                </ion-button>

                <ion-button *ngIf="chatGroup.status != 1 || (invitationtsOpen && !chatGroup.id)"
                            [disabled]="!f.form.valid"
                            (click)="saveChatGroup(f.form.valid)">
                    <ng-container *ngIf="!invitationtsOpen">
                        {{ 'BUTTON_SAVE' | translate }}
                    </ng-container>
                    <ng-container *ngIf="invitationtsOpen">
                        {{ 'CHAT_GROUP_SEND_INVITATIONS' | translate }} ({{ chatGroup.participantIds.length }})
                    </ng-container>
                </ion-button>

                <ion-button *ngIf="chatGroup.status == 1 && invitationtsOpen && chatGroup.id"
                            [disabled]="chatGroup.participantIds.length == 0"
                            (click)="sendInvitations()">
                    {{ 'CHAT_GROUP_SEND_INVITATIONS' | translate }} ({{ chatGroup.participantIds.length }})
                </ion-button>
            </ion-col>
        </ion-row>
        <ion-row *ngIf="plt.sizeSm"
                 class="two ion-no-padding"
                 [ngClass]="{'action-buttons': plt.sizeSm}">
            <ion-col size="6"
                     class="ion-no-padding">
                <ion-button class="btn-close"
                            (click)="close()">
                    {{ 'BUTTON_CANCEL' | translate }}
                </ion-button>
            </ion-col>
            <ion-col size="6"
                     class="ion-no-padding">
                <ion-button *ngIf="chatGroup.status == 1 && !invitationtsOpen"
                            [disabled]="!f.form.valid"
                            (click)="saveChatGroup(f.form.valid, !chatGroup.id)">
                    <ng-container *ngIf="chatGroup.id">
                        {{ 'BUTTON_SAVE' | translate }}
                    </ng-container>
                    <ng-container *ngIf="!chatGroup.id">
                        {{ 'BUTTON_SAVE_AND_NEXT' | translate }}
                    </ng-container>
                </ion-button>

                <ion-button *ngIf="chatGroup.status != 1 || (invitationtsOpen && !chatGroup.id)"
                            [disabled]="!f.form.valid"
                            (click)="saveChatGroup(f.form.valid)">
                    <ng-container *ngIf="!invitationtsOpen">
                        {{ 'BUTTON_SAVE' | translate }}
                    </ng-container>
                    <ng-container *ngIf="invitationtsOpen">
                        {{ 'CHAT_GROUP_SEND_INVITATIONS' | translate }} ({{ chatGroup.participantIds.length }})
                    </ng-container>
                </ion-button>

                <ion-button *ngIf="chatGroup.status == 1 && invitationtsOpen && chatGroup.id"
                            [disabled]="chatGroup.participantIds.length == 0"
                            (click)="sendInvitations()">
                    {{ 'CHAT_GROUP_SEND_INVITATIONS' | translate }} ({{ chatGroup.participantIds.length }})
                </ion-button>

            </ion-col>
        </ion-row>
    </ng-container>
    <ion-row *ngIf="autocompleteOpen && plt.sizeSm"
             class="action-buttons one ion-no-padding">
        <ion-col class="ion-no-padding ion-text-right">
            <ion-button class="btn-close"
                        (click)="autocompleteBlur(true)">
                {{ 'BUTTON_CANCEL' | translate }}
            </ion-button>
        </ion-col>
    </ion-row>
</ion-footer>